export const getThemeClasses = ({baseClass, theme}) => {
    const classes = [baseClass];

    if (theme !== undefined) {
        classes.push.apply(classes,
            theme.split(' ').map(modifier => `${baseClass}-theme-${modifier}`)
        );
    }

    return classes.join(' ');
}